// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeen":"cn_a bik_fm bik_vv bik_xg bik_h"};